<!--
 * @Description: 任务记录容器, 该组件初始化了列表数据
 * @Date: 2021-10-21 20:01:49
-->
<template>
  <div style="padding: 16px;box-sizing: border-box;background:#fff;">
    <task-list />
  </div>
</template>

<script>
import TaskList from '@/page/project-record/views/task-record/task-list';

export default {
  name: 'task-record-container',
  props: {
    statementId: {
      type: Number,
      default: 0
    },
    row: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  inject: ['isOpenedByOther'],
  provide() {
    return {
      isOpenedByOther:
        this.statementId || this.isOpenedByOther || this.hiddenHandleProject, // 以组件或者页面形式都算其他页面打开，无任何操作。
      otherQuery: this.row, // 以组件形式打开时使用。应该修改该参数，不管是页面还是组件都传入，后面的组件都使用该字段
      hasHandleProject: this.hasHandleProject // 只有【问卷、可配、数字拜访、协定服务】有操作与其他页面打开一样
    };
  },
  components: {
    TaskList
  },
  data() {
    return {
      formInline: {},
      hasHandleProject: {
        data: true
      }
    };
  },
  async created() {
    // 与OSS获取项目信息不一致
    const { id: projectId, type, projectType } = this.$store.state.homeProject;
    if (!projectId || !type) {
      throw new Error('缺少参数：projectId type');
    }
    if (![5, 17, 19, 20].includes(projectType)) {
      this.hasHandleProject.data = false;
    }
    await this.$store.dispatch('dataAnalysis/getProjectInfoById', {
      query: { projectId },
      projectItem: { type }
    });
  }
};
</script>

<style scoped>
/deep/ .el-row {
  padding: 8px 0;
}
/deep/ .el-button--medium {
  padding: 8px 20px !important;
}
/deep/ .el-select-dropdown__wrap {
  max-height: 600px !important;
}
</style>
